<template>
  <div class="mk-table">
    <span class="mk-table__description">
      {{$t('counterSelection.title')}}:
    </span>
    <span class="mk-table__subtitle">
      {{$t('counterSelection.subtitle')}}
    </span>
    <div class="mk-table__container">
      <TableButton
        v-for="(table, index) in tables.normal"
        :key="`shape-${index}`"
        :table="table"
        :closeCallback="selectTable"
      />
    </div>
    <span class="mk-table__section">
      {{$t('counterSelection.ledgeTitle')}}:
    </span>
    <div class="mk-table__container">
      <TableButton
        v-for="(table, index) in tables.ledge"
        :key="`shape-${index}`"
        :table="table"
        :closeCallback="selectTable"
      />
    </div>
    <OverrideConfigurationWarning
      v-if="overrideWarning"
      :closeCallback="() => { overrideWarning = false }"
      :submitCallback="overrideSubmit"
    />
  </div>
</template>

<script>
/**
 * Table Section
 * @author David <david.prenninger@gmx.de>
 *
 * This component is part of the main configurator Sections.
 * Its aim is to give the user a basic idea of all possible counter shapes.
 * The user needs to select one counter shape.
 * The selected is processed into a dimension which is than stored in the application state.
 */
import TableButton from '@/components/TableButton.vue';
import OverrideConfigurationWarning from '@/components/OverrideConfigurationWarning.vue';
import {
  TABLE_PLAIN,
  TABLE_CORNER,
  TABLE_UCORNER,
} from '../constants';

export default {
  components: {
    TableButton,
    OverrideConfigurationWarning,
  },
  data() {
    return {
      overrideWarning: false,
      overrideSubmit: () => {},
      tables: {
        ledge: [
          {
            id: TABLE_PLAIN,
            title: 'counterSelection.counter.straight',
            image: 'counter_single_ledge.png',
            ledge: true,
          },
          {
            id: TABLE_CORNER,
            title: 'counterSelection.counter.l',
            image: 'counter_l_ledge.png',
            ledge: true,
          },
          {
            id: TABLE_UCORNER,
            title: 'counterSelection.counter.u',
            image: 'counter_u_ledge.png',
            ledge: true,
          },
        ],
        normal: [
          {
            id: TABLE_PLAIN,
            title: 'counterSelection.counter.straight',
            image: 'counter_single.png',
          },
          {
            id: TABLE_CORNER,
            title: 'counterSelection.counter.l',
            image: 'counter_l.png',
          },
          {
            id: TABLE_UCORNER,
            title: 'counterSelection.counter.u',
            image: 'counter_u.png',
          },
        ],
      },
    };
  },
  computed: {
    objectSections() {
      return this.$store.getters.objectSections;
    },
    dimensions() {
      return this.$store.getters.dimensions;
    },
    tableId() {
      return this.$store.getters.tableId;
    },
  },
  methods: {
    selectTable(table) {
      console.log(table);
      console.log(Object.keys(this.dimensions).length);
      if (
        (Object.keys(this.dimensions).length !== 0
          || Object.keys(this.objectSections).length !== 0)
        && this.tableId !== table.id
      ) {
        this.overrideWarning = true;
        this.overrideSubmit = () => {
          this.$store.dispatch('loadSectionObjects', []);
          this.$store.dispatch('setTable', table);
        };
      } else {
        this.$store.dispatch('setTable', table);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-table {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;

  &__description {
    font-size: 20px;
    margin: 30px;
    margin-bottom: 10px;
  }

  &__subtitle {
    color: $c_primary_lighter;
    font-size: 16px;
    margin-bottom: 20px;
  }

  &__section {
    margin: 30px;
    color: $c_primary_lighter;
  }

  &__container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  }
}
</style>
